import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const DISABLEPREPAYMENTCONFIRMMODAL_LEGACY_FIELD_ORDER = [];

const {
  disablePrepaymentConfirmModalDescriptor: _generatedDisablePrepaymentConfirmModalDescriptor,
  disablePrepaymentConfirmModalModalDefinition,
  disablePrepaymentConfirmModalDashboardLayout,
  disablePrepaymentConfirmModalConfig,
  disablePrepaymentConfirmModalResolveConfig,
  disablePrepaymentConfirmModalProperties,
} = doodModalConfig(
  {
    name: "DisablePrepaymentConfirmModal",
    handle: "disable-prepayment-confirm-modal",
    internal_name: "DisablePrepaymentConfirmModal",
    componentType: 'DisablePrepaymentConfirmModalComponent',
    category: 'modal',
    description: "DisablePrepaymentConfirmModal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "disable-prepayment-confirm-modal",
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function disablePrepaymentConfirmModalDescriptor(): IBlockDescriptor;
export function disablePrepaymentConfirmModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function disablePrepaymentConfirmModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedDisablePrepaymentConfirmModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedDisablePrepaymentConfirmModalDescriptor, disablePrepaymentConfirmModalProperties, fieldOrder);
}

export {
  disablePrepaymentConfirmModalModalDefinition,
  disablePrepaymentConfirmModalDashboardLayout,
  disablePrepaymentConfirmModalProperties,
  disablePrepaymentConfirmModalConfig,
  disablePrepaymentConfirmModalResolveConfig,
};

export type DisablePrepaymentConfirmModalConfig = typeof disablePrepaymentConfirmModalConfig;
